function cov_d2l3fgwuw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateSubtract.tsx";
  var hash = "8c9ad163666434cceaf79d38ac2776e660984d5a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateSubtract.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8c9ad163666434cceaf79d38ac2776e660984d5a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_d2l3fgwuw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_d2l3fgwuw();
var Icon = (cov_d2l3fgwuw().s[0]++, {
  name: 'date-subtract',
  svg: "<path d=\"M14 16.75C14.6904 16.75 15.25 16.1904 15.25 15.5C15.25 14.8096 14.6904 14.25 14 14.25H10C9.30964 14.25 8.75 14.8096 8.75 15.5C8.75 16.1904 9.30964 16.75 10 16.75H14Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 1.75C7.69036 1.75 8.25 2.30964 8.25 3V4H15.75V3C15.75 2.30964 16.3096 1.75 17 1.75C17.6904 1.75 18.25 2.30964 18.25 3V4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V7C2 5.34315 3.34315 4 5 4H5.75V3C5.75 2.30964 6.30964 1.75 7 1.75ZM5.75 7V6.5H5C4.72386 6.5 4.5 6.72386 4.5 7V8.75H19.5V7C19.5 6.72386 19.2761 6.5 19 6.5H18.25V7C18.25 7.69036 17.6904 8.25 17 8.25C16.3096 8.25 15.75 7.69036 15.75 7V6.5H8.25V7C8.25 7.69036 7.69036 8.25 7 8.25C6.30964 8.25 5.75 7.69036 5.75 7ZM4.5 11.25V19C4.5 19.2761 4.72386 19.5 5 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V11.25H4.5Z\" fill=\"currentColor\"/>"
});
export default Icon;